import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import Integration from "~/cabinet/ts/data/online/config/integration/Integration";
import {PlatformInterface} from "~/cabinet/ts/data/integrations/Platform";
import BigIconFlexButton from "~/cabinet/vue/interface/button/BigIconFlexButton.vue";


const __default__ = {
    name: "IntegrationsAdditionalButtons"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    integration: {},
    platform: {}
  },
  emits: ["users-dialog", "remove"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit

return (_ctx: any,_cache: any) => {
  return (__props.integration && __props.platform)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (__props.platform.isPlatformWithUsers)
          ? (_openBlock(), _createBlock(BigIconFlexButton, {
              key: 0,
              descr: __props.integration.isUsersLinked ? 'Сопоставление операторов' : 'Сопоставьте операторов',
              "button-type": !__props.integration.isUsersLinked ? 'danger' : null,
              icon: __props.integration.isUsersLinked ? 'users' : 'users-slash',
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('users-dialog', __props.integration)))
            }, null, 8, ["descr", "button-type", "icon"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({integration: __props.integration}))),
        _createVNode(BigIconFlexButton, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(emits)('remove', __props.integration))),
          descr: "Удалить",
          icon: "times",
          "button-type": "danger"
        })
      ], 64))
    : _createCommentVNode("", true)
}
}

})